module.exports = __webpack_public_path__ + "img/hkpost_e.0533af50.jpg";